var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-row',[_c('ConfigurationHeader'),_c('InputCatalogName'),_c('SelectIndustry'),_c('SelectLanguage'),_c('SelectCurrency'),_c('InputCatalogLink')],1)}
var staticRenderFns = []

export { render, staticRenderFns }